export default __webpack_public_path__ + "static/media/Punto_03_Monumento_4_Mori_e_Fortezza_Vecchia_ITA_Def.bc148476.aac";